/*
 * @Author: liyxt
 * @Date: 2020-05-06 14:00:41
 * @LastEditors: liyxt
 * @LastEditTime: 2020-05-29 09:58:36
 * @Description: file content
 */ 
import React, { Component } from 'react';
import OriginStep from 'bee-step';
const { Steps } = OriginStep;
require('bee-step/build/Step.css');
require('./index.less');

export default class Step extends Component {
    render() {
        return <OriginStep {...this.props} />;
    }
}

Step.Steps = Steps;
